import AppRecord from './AppRecord.js'

class EntityReportingGroup extends AppRecord {
}

export default EntityReportingGroup
